
import React from 'react';
import PropTypes from 'prop-types';
import { CSSTransition } from 'react-transition-group';

// 1. 'mdc-Snackbar' makes sure all children are centered on page
// 2. 'mdc-Snackbar-background' creates dark background
// 3. 'mdc-Snackbar-content' wraps content so it can animate opacity independently from background
var Snackbar = function Snackbar(_ref) {
  var text = _ref.text,
      action = _ref.action,
      onAction = _ref.onAction,
      visible = _ref.visible;
  return React.createElement(
    CSSTransition,
    { 'in': visible, timeout: 500, classNames: 'fade', unmountOnExit: true, mountOnEnter: true, appear: true },
    React.createElement(
      'div',
      { className: 'mdc-Snackbar' },
      React.createElement(
        'div',
        { className: 'mdc-Snackbar-background' },
        React.createElement(
          'div',
          { className: 'mdc-Snackbar-content' },
          React.createElement(
            'span',
            { className: 'mdc-Snackbar-text' },
            text
          ),
          action && React.createElement('input', {
            type: 'button',
            className: 'mdc-Snackbar-action',
            onClick: onAction,
            value: action
          })
        )
      )
    )
  );
};

Snackbar.propTypes = {
  text: PropTypes.node,
  action: PropTypes.string,
  onAction: PropTypes.func,
  visible: PropTypes.bool
};

export default Snackbar;


//////////////////
// WEBPACK FOOTER
// ../es/js/snackbar/index.js
// module id = 295
// module chunks = 0